import { EF_SYNC_SOURCE_TYPES } from '../../../shared/constants';

const TERMINAL_SYNC_STATUSES = new Set(['SUCCESS', 'PARTIAL', 'FAILED']);
const ACTIVE_SYNC_STATUSES = new Set(['QUEUED', 'STARTED']);

export const isTerminalSyncStatus = (status) => TERMINAL_SYNC_STATUSES.has(status);
export const isActiveSyncStatus = (status) => ACTIVE_SYNC_STATUSES.has(status);

export const ALL_SYNC_SOURCE_SCOPE = 'ALL';

/** Derive the canonical storage scope from a normalized source_types list. */
export const canonicalSyncSourceScope = (sourceTypes) => {
  const requested = (sourceTypes || []).filter(
    (sourceType) => EF_SYNC_SOURCE_TYPES.includes(sourceType),
  );
  const unique = [...new Set(requested)];
  if (unique.length === 0 || unique.length === EF_SYNC_SOURCE_TYPES.length) {
    return ALL_SYNC_SOURCE_SCOPE;
  }
  return unique.join('-');
};